module.exports = __webpack_public_path__ + "static/media/ss12.48428fa0.jpg";